import { icons } from '../../lib/helpers/icons';
import { AppIconType } from '../../lib/typegen/app-icon-type';
import style from './style.module.scss';

interface MainMessageBoxProps extends React.HTMLAttributes<HTMLElement> {
	icon: AppIconType;
	message: string;
}

export default function MainMessageBox({ icon, message, className, ...rest }: MainMessageBoxProps) {
	const Icon = icons[icon];

	return (
		<main {...rest} className={[style.main, className].join(' ')}>
			<Icon className={style.main__icon} />
			<p className={style.main__message}>{message}</p>
		</main>
	);
}
